export default "__VITE_ASSET__CZru3v$a__"